import type { Issue, IssueCode, Severity } from './types.ts';

export function issue(severity: Severity, code: IssueCode, message: string, stepId?: string, field?: string): Issue {
  const out: Issue = { severity, code, message };
  if (stepId !== undefined) out.stepId = stepId;
  if (field !== undefined) out.field = field;
  return out;
}

export function hasErrors(issues: readonly Issue[]): boolean {
  return issues.some((i) => i.severity === 'error');
}
